export default {
	InvoicesCheckingUpdate: [],
	InvoicesCheckingUpdateTotal: 0,
	viewTourGuide: false,
	sizePdf: 0
};
